import { Box, MenuItem } from "@mui/material";
import React from "react";
import CustomSelect from "../../../../../components/ui/Select";
import CustomTextField from "../../../../../components/ui/Textfield";
import { StepComponentProps } from "../../AddBookingV2";
import VenueSearchField from "../VenueSearchField";
import StepHeader from "../StepHeader";

const ConferenceServiceStep: React.FC<StepComponentProps> = ({
  bookingData,
  setBookingData,
  isEdit,
  onUpdate,
  submitting,
}) => {
  const handleChange = (field: string, value: unknown) =>
    setBookingData((prev) => ({ ...prev, [field]: value as string }));

  return (
    <Box
      sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 3 }}
    >
      <StepHeader
        title="Service Details"
        isEdit={isEdit}
        onUpdate={onUpdate}
        submitting={submitting}
      />

      <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 3 }}>
        <CustomSelect
          label="Conference Type"
          value={bookingData.conference_type || ""}
          onChange={(e) => handleChange("conference_type", e.target.value)}
        >
          <MenuItem value="summit">Summit</MenuItem>
          <MenuItem value="workshop">Workshop</MenuItem>
          <MenuItem value="symposium">Symposium</MenuItem>
          <MenuItem value="dinner">Dinner</MenuItem>
          <MenuItem value="breakfast_meeting">Breakfast Meeting</MenuItem>
          <MenuItem value="congress">Congress</MenuItem>
          <MenuItem value="conference">Conference</MenuItem>
          <MenuItem value="other">Other</MenuItem>
        </CustomSelect>
        <CustomTextField
          label="Title"
          value={bookingData.title || ""}
          onChange={(e) => handleChange("title", e.target.value)}
        />
        <CustomTextField
          label="Subtitle"
          value={bookingData.sub_title || ""}
          onChange={(e) => handleChange("sub_title", e.target.value)}
        />
      </Box>

      <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 3 }}>
        <CustomTextField
          label="Host Name"
          value={bookingData.hosts || ""}
          onChange={(e) => handleChange("hosts", e.target.value)}
        />
        <CustomTextField
          label="Guest Name"
          value={bookingData.guests || ""}
          onChange={(e) => handleChange("guests", e.target.value)}
        />
        <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
          <CustomTextField
            label="Start Time"
            type="time"
            InputLabelProps={{ shrink: true }}
            value={bookingData.start_time || ""}
            onChange={(e) => handleChange("start_time", e.target.value)}
          />
          <CustomTextField
            label="End Time"
            type="time"
            InputLabelProps={{ shrink: true }}
            value={bookingData.end_time || ""}
            onChange={(e) => handleChange("end_time", e.target.value)}
          />
        </Box>
      </Box>

      <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 3 }}>
        <CustomTextField
          label="Start Date"
          type="date"
          InputLabelProps={{ shrink: true }}
          value={bookingData.start_date_of_event || ""}
          onChange={(e) => handleChange("start_date_of_event", e.target.value)}
        />
        <CustomTextField
          label="End Date"
          type="date"
          InputLabelProps={{ shrink: true }}
          value={bookingData.end_date_of_event || ""}
          onChange={(e) => handleChange("end_date_of_event", e.target.value)}
        />
        <Box />
      </Box>

      <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 3 }}>
        <CustomTextField
          label="Expected Audience Size"
          type="number"
          value={bookingData.expected_audience_size || ""}
          onChange={(e) =>
            handleChange("expected_audience_size", e.target.value)
          }
        />
        <CustomSelect
          label="Access Type"
          value={bookingData.access_type || ""}
          onChange={(e) => handleChange("access_type", e.target.value)}
        >
          <MenuItem value="public">Public</MenuItem>
          <MenuItem value="private">Private</MenuItem>
        </CustomSelect>
        <Box />
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr",
          gap: 3,
          alignItems: "start",
        }}
      >
        <VenueSearchField
          bookingData={bookingData}
          setBookingData={setBookingData}
        />
        <CustomTextField
          label="Address One"
          value={bookingData.address_one || ""}
          onChange={(e) => handleChange("address_one", e.target.value)}
          disabled={bookingData.areAddressFieldsDisabled}
        />
        <CustomTextField
          label="Address Two"
          value={bookingData.address_two || ""}
          onChange={(e) => handleChange("address_two", e.target.value)}
          disabled={bookingData.areAddressFieldsDisabled}
        />
      </Box>

      <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 3 }}>
        <CustomTextField
          label="Suburb"
          value={bookingData.suburb || ""}
          onChange={(e) => handleChange("suburb", e.target.value)}
          disabled={bookingData.areAddressFieldsDisabled}
        />
        <CustomTextField
          label="City"
          value={bookingData.city || ""}
          onChange={(e) => handleChange("city", e.target.value)}
          disabled={bookingData.areAddressFieldsDisabled}
        />
        <Box />
      </Box>

      <CustomTextField
        label="Conference Description"
        value={bookingData.conference_description || ""}
        onChange={(e) => handleChange("conference_description", e.target.value)}
        multiline
        rows={4}
        fullWidth
        placeholder="Briefly describe the purpose and agenda..."
      />
    </Box>
  );
};

export default ConferenceServiceStep;
